/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryOrder } from '../../models/delivery-order';

export interface CompleteDeliveryOrder$Params {
  uuid: string;
      body: DeliveryOrder
}

export function completeDeliveryOrder(http: HttpClient, rootUrl: string, params: CompleteDeliveryOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryOrder>> {
  const rb = new RequestBuilder(rootUrl, completeDeliveryOrder.PATH, 'patch');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryOrder>;
    })
  );
}

completeDeliveryOrder.PATH = '/delivery-orders/{uuid}/complete';
